
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'


    class ImportRejectListRequest {
        StoreId: number;
        ShipNumber: Array<string> = [];
        ShipNumberInfo: string;
        constructor() {

        }
    }

    @Component({
        components: { }
    })
    export default class importkeyword extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        request: ImportRejectListRequest = new ImportRejectListRequest();
        created() {

        }
        async save() {
            var reg = /[\r\n]+/g;
            if (!this.request.ShipNumberInfo || this.request.ShipNumberInfo.length == 0) {
                this.$Message.error('快递单号不能为空');
            }
            else {
                var ImportString = this.request.ShipNumberInfo.replace(/[\r\n]+/g, ",");
                let list = ImportString.replace('，', ',').split(',');

                await this.$store.dispatch({
                    type: 'backoverseasreturnhandle/ConfirmRejectionList',
                    data: { StoreId: this.request.StoreId, ShipNumber: list }
                });
            }
        }
        cancel() {
            (this.$refs.ImportrejectlistForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.request.StoreId = this.$store.state.returnrejection.importrejectlistStoreId;
            }
        }
    }
